import { RadioButtonProps } from '../../shared/modules/ui-kit/models/interfaces';

export const YES_NO_GROUP: RadioButtonProps[] = [
  { viewValue: 'Yes', value: true },
  { viewValue: 'No', value: false },
];
